import { ProjectLite } from "@/app/types/project/ProjectLite";
import { ProjectPromptContext } from "@/app/types/project/ProjectPromptContext";

export class UProject {
  private static readonly INDENT = "\n      ";

  public static resolveCurrent(projects: ProjectLite[], savedId?: number): ProjectLite | undefined {
    const restored = savedId !== undefined ? projects.find((p) => p.id === savedId) : undefined;
    return restored || projects[0] || undefined;
  }

  public static buildPromptContext(project: ProjectPromptContext): string {
    return [
      `Project Name: ${project.name}`,
      project.description ? `Project Description: ${project.description}` : null,
    ]
      .filter(Boolean)
      .join(UProject.INDENT);
  }
}
